module.exports = __webpack_public_path__ + "img/Mockup5.b93e5d68.webp";